/**
 * custom-atc.js
 * Fixes cart drawer not refreshing after add-to-cart / remove-from-cart.
 *
 * Root cause: z__jsAjaxCart caches cart HTML for 5 seconds. After adding or
 * removing an item the cache is stale but still served, so the drawer shows
 * old content (missing item or item still visible). The drawer also opens on
 * a fixed 800 ms timer regardless of whether fresh data has loaded.
 *
 * This file monkey-patches three methods on window.PXUTheme.jsAjaxCart at
 * DOMContentLoaded so we never touch the vendor file directly.
 */
(function () {
  "use strict";

  function patchAjaxCart() {
    var cart = window.PXUTheme.jsAjaxCart;
    if (!cart) return;

    /* ------------------------------------------------------------------ */
    /*  1. loadCartData — always bypass cache after a cart mutation        */
    /* ------------------------------------------------------------------ */
    var _originalLoadCartData = cart.loadCartData.bind(cart);

    cart._forceRefresh = false;

    cart.loadCartData = function () {
      if (this._forceRefresh) {
        this._forceRefresh = false;
        this.cartCache = null;
      }
      return _originalLoadCartData();
    };

    /* ------------------------------------------------------------------ */
    /*  2. addToCart — clear cache before updateView, open drawer after    */
    /*     data is ready instead of on a blind 800 ms timer               */
    /* ------------------------------------------------------------------ */
    cart.addToCart = function ($addToCartForm) {
      var self = this;
      var $addToCartBtn = $addToCartForm.find(".button--add-to-cart");
      self.recipientForm = $addToCartForm[0].querySelector(
        "[data-recipient-form]"
      );

      if (self.recipientForm) {
        self.recipientForm.classList.remove("recipient-form--has-errors");
      }

      $addToCartForm.removeClass("shopify-product-form--unselected-error");

      if ($addToCartBtn[0].hasAttribute("data-options-unselected")) {
        var cartWarning =
          '<p class="cart-warning__message animated bounceIn">' +
          window.PXUTheme.translation.select_variant +
          "</p>";
        $(".warning").remove();
        $addToCartForm
          .addClass("shopify-product-form--unselected-error")
          .find(".cart-warning")
          .html(cartWarning);
        $addToCartBtn.removeAttr("disabled").removeClass("disabled");
        $addToCartBtn.find(".icon").removeClass("zoomOut").addClass("zoomIn");
        $addToCartBtn
          .find("span:not(.icon)")
          .text($addToCartBtn.data("label"))
          .removeClass("zoomOut")
          .addClass("zoomIn");
        return;
      }

      if (self.isUpdating) return;
      self.isUpdating = true;

      $addToCartBtn.attr("disabled", "disabled").addClass("disabled");
      $addToCartBtn.find(".nice-frame").text("Adding item...");

      $.ajax({
        url: "/cart/add.js",
        dataType: "json",
        type: "post",
        data: $addToCartForm.serialize(),
        success: function (product) {
          $addToCartBtn.find(".checkmark").addClass("checkmark-active");

          self.cartCache = null;
          self._forceRefresh = true;

          self
            .updateView()
            .then(function () {
              self.isUpdating = false;

              $addToCartBtn.removeAttr("disabled").removeClass("disabled");
              $addToCartBtn.find(".checkmark").removeClass("checkmark-active");
              $addToCartBtn
                .find(".text, .icon")
                .removeClass("zoomOut")
                .addClass("fadeInDown");

              var showCartUI = function () {
                var $el;
                if (!isScreenSizeLarge()) {
                  $el = $(".mobile-header [data-ajax-cart-trigger]");
                  window.PXUTheme.scrollToTop($el);
                } else {
                  $el = $("[data-ajax-cart-trigger]");
                }
                $el.addClass("show-mini-cart");
                $addToCartBtn.find("span").removeClass("fadeInDown");
                self.showDrawer();
              };

              $addToCartBtn.one(
                "webkitAnimationEnd oanimationend msAnimationEnd animationend",
                showCartUI
              );

              setTimeout(showCartUI, 900);

              $addToCartBtn.find(".nice-frame").text("Add to cart");
            })
            .catch(function () {
              self.isUpdating = false;
              $addToCartBtn.removeAttr("disabled").removeClass("disabled");
              $addToCartBtn.find(".nice-frame").text("Add to cart");
            });

          if (
            window.PXUTheme.jsCart &&
            window.location.pathname === "/cart"
          ) {
            clearTimeout(self.cartPageUpdateTimeout);
            self.cartPageUpdateTimeout = setTimeout(function () {
              $.ajax({
                dataType: "html",
                url: "/cart",
                success: function (html) {
                  var cartForm = $(html).find(".cart__form");
                  if (cartForm.length) {
                    $(".cart__form").replaceWith(cartForm);
                  }
                },
              });
            }, 300);
          }
        },
        error: function (XMLHttpRequest) {
          self.isUpdating = false;
          var response = eval("(" + XMLHttpRequest.responseText + ")");
          $(".warning").remove();

          if (response.errors && response.errors.email) {
            self.recipientForm.classList.add("recipient-form--has-errors");
          } else {
            var warn =
              '<p class="cart-warning__message animated bounceIn">' +
              response.description.replace("All 1 ", "All ") +
              "</p>";
            $addToCartForm.find(".cart-warning").html(warn);
          }

          $addToCartBtn.removeAttr("disabled").removeClass("disabled");
          $addToCartBtn
            .find(".icon")
            .removeClass("zoomOut")
            .addClass("zoomIn");
          $addToCartBtn
            .find("span:not(.icon)")
            .text($addToCartBtn.data("label"))
            .removeClass("zoomOut")
            .addClass("zoomIn");
          $addToCartBtn.find(".nice-frame").text("Add to cart");
        },
      });
    };

    /* ------------------------------------------------------------------ */
    /*  3. removeFromCart — clear cache so the next updateView is fresh    */
    /* ------------------------------------------------------------------ */
    cart.removeFromCart = function (lineID, callback) {
      var self = this;
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&line=" + lineID,
        dataType: "json",
        success: function (cart) {
          self.cartCache = null;
          self._forceRefresh = true;
          self.updateView();

          if (window.PXUTheme.jsCart) {
            window.PXUTheme.jsCart.removeFromCart(lineID);
          }
        },
        error: function (XMLHttpRequest, textStatus) {
          var response = eval("(" + XMLHttpRequest.responseText + ")");
          response = response.description;
          console.error("Error removing item from cart:", response);
        },
      });
    };
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      setTimeout(patchAjaxCart, 0);
    });
  } else {
    setTimeout(patchAjaxCart, 0);
  }
})();
